"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepare1155ContractsInitialValues = exports.erc1155EditContractFilter = exports.erc1155CreateContractFilter = void 0;
const types_1 = require("../../../../types");
const erc1155CreateContractFilter = (service) => ({ title, description, address, imageUrl, merchantId }) => ({
    title,
    description,
    address,
    imageUrl,
    merchantId: (service === types_1.ServiceType.OFFICE && merchantId) || undefined,
});
exports.erc1155CreateContractFilter = erc1155CreateContractFilter;
const erc1155EditContractFilter = (service) => ({ title, description, contractStatus, imageUrl, symbol, parameters, merchantId }) => ({
    title,
    description,
    imageUrl,
    contractStatus,
    symbol: (service === types_1.ServiceType.ADMIN && symbol) || undefined,
    parameters: (service === types_1.ServiceType.ADMIN && parameters) || undefined,
    merchantId: (service === types_1.ServiceType.OFFICE && merchantId) || undefined,
});
exports.erc1155EditContractFilter = erc1155EditContractFilter;
const prepare1155ContractsInitialValues = (service) => ({ id, title, description, imageUrl, address, contractStatus, symbol, parameters, merchantId, }) => {
    return {
        id,
        title,
        description,
        address,
        imageUrl,
        contractStatus,
        symbol,
        parameters: JSON.stringify(parameters),
        merchantId: (service === types_1.ServiceType.OFFICE && merchantId) || undefined,
    };
};
exports.prepare1155ContractsInitialValues = prepare1155ContractsInitialValues;
//# sourceMappingURL=schemas.js.map